import React from 'react';
import { Container, HeadingText } from '@paypalcorp/pp-react';
import { Message } from '@paypalcorp/worldready-react';
import PropTypes from 'prop-types';
import { FPTI_DATA } from '../../../common/propTypes';
import BackButton from '../../../shared/BackButton';
import AlertsPanel from '../../../home/containers/panels/AlertsPanel';

const HeroPanel = function (props) {
  const { FPTIData, pageName } = props;

  return (
    <Container className="sh-contactus-hero-panel" data-testid="sh-contactus-hero-panel">
      <BackButton FPTIData={FPTIData} />
      <AlertsPanel pageName={pageName} />
      <h1 className="sh-contactus-header-label-one" size="lg" data-testid="sh-contactus-header-label-one">
        <Message id="smarthelp.app.hero.header.label.one" />
      </h1>
      <HeadingText className="sh-contactus-header-label-two" size="sm" data-testid="sh-contactus-header-label-two">
        <Message id="smarthelp.app.hero.header.label.two" />
      </HeadingText>
    </Container>
  );
};

HeroPanel.propTypes = {
  FPTIData: PropTypes.shape(FPTI_DATA).isRequired,
  pageName: PropTypes.string.isRequired,
};

export default HeroPanel;
